const tags = {
  // MAIN
  '/': {
    title: {
      en: 'GoVPSFX',
      ru: 'GoVPSFX',
    },
    description: {
      en: 'VPS server for forex trading',
      ru: 'VPS сервер для форекс тоговли',
    },
    keywords: {
      en: [
        'VPS servers for forex trading for free',
        'Free VPS server for forex trading',
      ],
      ru: [
        'vps серверы для форекс бесплатно',
        'free vps server forex бесплатно',
        'впс сервер для форекс бесплатный',
      ],
    },
  },
  // VPS
  '/vps-free': {
    title: {
      en: 'Free VPS Servers for Forex | GoVPSFX',
      ru: 'Бесплатные VPS-серверы для Форекс | GoVPSFX',
    },
    description: {
      en: 'Get free VPS servers for Forex trading. Reliable and fast servers for stable operation of trading platforms. Start now and improve your results',
      ru: 'Получите бесплатные VPS серверы для форекс-трейдинга. Надежные и быстрые серверы для стабильной работы торговых платформ. Начните прямо сейчас и улучшите свои результаты',
    },
    keywords: {
      en: [
        'Free VPS servers',
        'Forex VPS',
        'Trading servers',
        'Free servers for Forex',
        'Reliable VPS',
        'Fast VPS servers',
        'Forex hosting',
        'Free hosting for traders',
        'VPS for trading',
        'Forex platforms',
      ],
      ru: [
        'Бесплатные VPS серверы',
        'Форекс VPS',
        'Трейдинг серверы',
        'Бесплатные серверы для форекс',
        'Надежные VPS',
        'Быстрые VPS серверы',
        'Форекс хостинг',
        'Бесплатный хостинг для трейдеров',
        'VPS для трейдинга',
        'Форекс платформы',
      ],
    },
  },
  '/vps-paid': {
    title: {
      en: 'Rent VPS servers for Forex | GoVPSFX',
      ru: 'Аренда VPS-серверов для Форекс | GoVPSFX',
    },
    description: {
      en: 'With us, you can rent a reliable VPS for trading at a low price and get a 90% spread rebate',
      ru: 'У нас вы сможете арендовать надежный VPS для трейдинга по низкой цене и получить 90% возврат спреда',
    },
    keywords: {
      en: [
        'Spread rebate',
        'Rebate service',
        'Forex rebate',
        'Rebate',
        'VPS server',
        'VPS server rental',
        'Trading advisor',
        'Trading robot',
        'VPS',
        'Trading expert',
      ],
      ru: [
        'возврат спред',
        'рибейт сервис',
        'рибейт форекс',
        'рибейт',
        'vps сервер',
        'аренда vps сервера',
        'торговый советник',
        'торговый робот',
        'vps',
        'торговый эксперт',
      ],
    },
  },
  '/vps-manual': {
    title: {
      en: 'Instructions | GoVPSFX',
      ru: 'Инструкции | GoVPSFX',
    },
    description: {
      en: 'How to get on your Forex VPS server. How to properly load a robot on your VPS server. Check ping to brokers trading servers',
      ru: 'как попасть на VPS-сервер для Форекс. Как правильно загрузить робота на ваш VPS-сервер. Проверить пинг до торговых серверов брокеров',
    },
    keywords: {
      en: ['vps server', 'vps server for forex', 'vps forex', 'forex vps'],
      ru: ['vps сервер', 'vps сервер для форекс', 'vps форекс', 'впс форекс'],
    },
  },
  '/guide': {
    title: {
      en: 'VPS guide | GoVPSFX',
      ru: 'VPS справочник | GoVPSFX',
    },
    description: {
      en: 'Here you will find the most detailed information about what VPS Forex is and how it will be useful for you in trading.',
      ru: 'здесь вы найдете максимально подробную информацию, о том, что за зверь такой VPS Форекс, и чем он будет полезен вам в трейдинге.',
    },
    keywords: {
      en: ['vps server', 'vps server for forex', 'vps forex', 'forex vps'],
      ru: ['vps сервер', 'vps сервер для форекс', 'vps форекс', 'впс форекс'],
    },
  },
  '/video': {
    title: {
      en: 'Video Tutorials | GoVPSFX',
      ru: 'Видео-уроки | GoVPSFX',
    },
    description: {
      en: 'Here you can find all the video tutorials you need.',
      ru: 'Здесь вы сможете найти все необходимые видео инструкции.',
    },
    keywords: {
      en: [
        'vps server',
        'Expert Advisor installation',
        'trading advisor',
        'forex broker',
        'trading strategy',
      ],
      ru: [
        'vps-сервер',
        'установка торгового советника',
        'торговый советник',
        'форекс брокер',
        'торговая стратегия',
      ],
    },
  },
  // MONITORING
  '/monitoring': {
    title: {
      en: 'Online Monitoring - GoVPSFX',
      ru: 'Онлайн мониторинг - GoVPSFX',
    },
    description: {
      en: 'Monitor your trading accounts in real-time with our reliable online monitoring. Get instant notifications and analyze the effectiveness of your strategies. Improve your results with us!',
      ru: 'Следите за своими торговыми счетами в режиме реального времени с нашим надежным онлайн мониторингом. Получайте мгновенные уведомления и анализируйте эффективность своих стратегий. Улучшите свои результаты с нами!',
    },
    keywords: {
      en: [
        'Online monitoring of trading accounts',
        'Forex monitoring',
        'Trading account control',
        'Trading monitoring',
        'Real-time Forex',
        'Trading account analysis',
        'Trade notifications',
        'Trading account management',
        'Forex analytics',
        'Trading tools',
      ],
      ru: [
        'Онлайн мониторинг торговых счетов',
        'Форекс мониторинг',
        'Контроль торговых счетов',
        'Мониторинг трейдинга',
        'Реальное время форекс',
        'Анализ торговых счетов',
        'Уведомления о трейдах',
        'Управление торговыми счетами',
        'Форекс аналитика',
        'Трейдинг инструменты',
      ],
    },
  },
  '/monitoring-manual': {
    title: {
      en: 'Instructions on GoVPSFX Online Monitoring',
      ru: 'Инструкции по Онлайн Мониторингу GoVPSFX',
    },
    description: {
      en: 'Learn how to effectively monitor and manage your trading accounts with our VPS hosting. Step-by-step instructions for setting up and using online monitoring to always be aware of the status of your investments.',
      ru: 'Узнайте, как эффективно отслеживать и управлять вашими торговыми счетами с помощью нашего VPS хостинга. Пошаговые инструкции для настройки и использования онлайн мониторинга, чтобы всегда быть в курсе состояния ваших инвестиций.',
    },
    keywords: {
      en: [
        'Online monitoring of trading accounts',
        'Forex trading',
        'VPS hosting for traders',
        'Trading accounts management',
        'Monitoring Instructions',
        'Trading platforms',
        'Trading Automation',
        'Trading account security',
        'Analyzing trading data',
        'Monitoring setup',
      ],
      ru: [
        'Онлайн мониторинг торговых счетов',
        'Форекс трейдинг',
        'VPS хостинг для трейдеров',
        'Управление торговыми счетами',
        'Инструкции по мониторингу',
        'Торговые платформы',
        'Автоматизация трейдинга',
        'Безопасность торговых счетов',
        'Анализ торговых данных',
        'Настройка мониторинга',
      ],
    },
  },
  // REBATE
  '/rebate': {
    title: {
      en: 'Rebate Service - GoVPSFX',
      ru: 'Рибейт сервис - GoVPSFX',
    },
    description: {
      en: 'Earn rebates on every trade and get a portion of the spread back. Increase your profits with our rebate program for Forex traders. Sign up now and start saving!',
      ru: 'Получайте рибейт на каждую сделку и возвращайте часть спреда. Увеличьте свою прибыль с нашей программой рибейта для форекс-трейдеров. Зарегистрируйтесь сейчас и начните экономить!',
    },
    keywords: {
      en: [
        'Rebate',
        'Rebate service',
        'Brokerage company',
        'VPS server',
        'VPS',
        'Forex rebate',
        'Spread rebate',
        'Forex rebate program',
        'Rebate on trades',
        'Forex savings',
        'Forex bonuses',
        'Rebate for traders',
        'Forex commission rebate',
      ],
      ru: [
        'рибейт',
        'рибейт сервис',
        'брокерская компания',
        'vps-сервер',
        'vps',
        'Рибейт форекс',
        'Возврат спреда',
        'Форекс рибейт программа',
        'Рибейт на сделки',
        'Экономия на форекс',
        'Форекс бонусы',
        'Рибейт для трейдеров',
        'Возврат комиссии форекс',
      ],
    },
  },
  '/rebate-brokers': {
    title: {
      en: 'Rebate brokers ranking - GoVPSFX',
      ru: 'Рейтинг рибейт брокеров - GoVPSFX',
    },
    description: {
      en: 'Discover the best brokers for rebate service and maximize your profits with our VPS hosting. Our rating will help you choose a reliable partner for successful forex trading.',
      ru: 'Откройте для себя лучших брокеров для рибейт сервиса и максимизируйте свою прибыль с помощью нашего VPS хостинга. Наш рейтинг поможет вам выбрать надежного партнера для успешного трейдинга на Форекс.',
    },
    keywords: {
      en: [
        'Forex brokers rating',
        'Rebate Service',
        'Best brokers for traders',
        'VPS hosting for trading',
        'Reliable Forex brokers',
        'Choosing a broker',
        'Ribate Terms',
        'Forex Trading',
        'Brokers Analysis',
        'Affiliate Programs',
      ],
      ru: [
        'Рейтинг форекс брокеров',
        'Рибейт сервис',
        'Лучшие брокеры для трейдеров',
        'VPS хостинг для трейдинга',
        'Надежные форекс брокеры',
        'Выбор брокера',
        'Условия рибейт',
        'Трейдинг на Форекс',
        'Анализ брокеров',
        'Партнерские программы',
      ],
    },
  },
  // PARTNER
  '/classic': {
    title: {
      en: 'Affiliate Program | GoVPSFX',
      ru: 'Партнерская программа | GoVPSFX',
    },
    description: {
      en: 'The GoVPSFX Affiliate Program is an opportunity to earn additional income online',
      ru: 'Партнерская программа от GoVPSFX - это возможность дополнительно заработать в Интернете',
    },
    keywords: {
      en: [
        'Affiliate program',
        'Affiliate earnings',
        'Affiliate links',
        'Additional online income',
        'VPS servers',
        'VPS',
        'VPS rental',
      ],
      ru: [
        'партнерская программа',
        'партнерский заработок',
        'партнерка',
        'партнерские ссылки',
        'дополнительный заработок в интернете',
        'vps серверы',
        'vps',
        'аренда vps',
      ],
    },
  },
  '/multilevel': {
    title: {
      en: 'Multi-Level Affiliate Program | GoVPSFX',
      ru: 'Многоуровневая партнерская программа | GoVPSFX',
    },
    description: {
      en: 'The GoVPSFX Affiliate Program is an opportunity to earn additional income online',
      ru: 'Партнерская программа от GoVPSFX - это возможность дополнительно заработать в Интернете',
    },
    keywords: {
      en: [
        'Affiliate program',
        'Affiliate earnings',
        'Affiliate links',
        'Additional online income',
        'VPS servers',
        'VPS',
        'VPS rental',
        'Multi-level',
        'Multi-level affiliate program',
      ],
      ru: [
        'партнерская программа',
        'партнерский заработок',
        'партнерка',
        'партнерские ссылки',
        'дополнительный заработок в интернете',
        'vps серверы',
        'vps',
        'аренда vps',
        'мультилевел',
        'многоуровневая партнерка',
      ],
    },
  },
  '/white-label': {
    title: {
      en: 'White Label Program | GoVPSFX',
      ru: 'Программа White Label | GoVPSFX',
    },
    description: {
      en: 'White Label is a comprehensive turnkey technical solution that includes a multifunctional traders personal account and an administrative panel.',
      ru: 'White Label это комплексное техническое решение под ключ, которое включает в себя многофункциональный личный кабинет трейдера и административную панель.',
    },
    keywords: {
      en: [
        'Affiliate program',
        'White label',
        'GoVPSFX',
        'VPS rental',
        'Trading advisor',
        'Advisor',
        'VPS servers',
      ],
      ru: [
        'партнерская программа',
        'white label',
        'govpsfx',
        'аренда vps',
        'торговый советник',
        'советник',
        'vps серверов',
      ],
    },
  },
  '/resale': {
    title: {
      en: 'Reseller Program | GoVPSFX',
      ru: 'Программа реселлинга | GoVPSFX',
    },
    description: {
      en: 'API documentation for services: VPS rental, subscription to online account monitoring.',
      ru: 'API-документация для услуг: аренда VPS, подписка на онлайн мониторинг счетов.',
    },
    keywords: {
      en: [
        'VPS server',
        'VPS',
        'VPS rental',
        'API',
        'Brokerage company',
        'Trading advisor',
        'Reseller program',
      ],
      ru: [
        'vps сервер',
        'vps',
        'vps аренда',
        'api',
        'брокерская компания',
        'торговый советник',
        'программа реселлинга',
      ],
    },
  },
  // HELP
  '/brokers': {
    title: {
      en: 'Brokers - GoVPSFX',
      ru: 'Брокеры - GoVPSFX',
    },
    description: {
      en: 'The Forex brokers rating is based on the popularity of each Forex broker among experienced traders and novice speculators.',
      ru: 'Рейтинг форекс брокеров выстроен по принципу наибольшей популярности того или иного форекс брокера среди опытных трейдеров и начинающих спекулянтов.',
    },
    keywords: {
      en: [
        'Forex brokers rating',
        'Forex broker',
        'Broker',
        'Forex rating',
        'Brokers rating',
      ],
      ru: [
        'Рейтинг форекс брокеров',
        'форекс брокер',
        'брокер',
        'форекс рейтинг',
        'рейтинг брокеров',
      ],
    },
  },
  '/courses': {
    title: {
      en: 'Basic Trading Courses | GoVPSFX',
      ru: 'Курсы по основам торговли | GoVPSFX',
    },
    description: {
      en: 'We provide basic courses that cover trading fundamentals, technical analysis, trading strategies and risk management, as well as current topics such as cryptocurrency and binary options trading',
      ru: 'Мы предоставляем базовые курсы, которые охватывают основы торговли, технический анализ, стратегии торговли и управление рисками, а также актуальные темы, такие как торговля криптовалютами и бинарными опционами',
    },
    keywords: {
      en: [
        'Forex Training Courses',
        'Cryptocurrency Courses',
        'Binary Options Training',
        'CFD courses',
        'Trading Training',
        'Financial Courses',
        'Trading Education',
        'Forex Education',
        'Cryptocurrency Training',
        'CFD Training',
      ],
      ru: [
        'Обучающие курсы форекс',
        'Курсы по криптовалютам',
        'Бинарные опционы обучение',
        'CFD курсы',
        'Трейдинг обучение',
        'Финансовые курсы',
        'Обучение трейдингу',
        'Форекс образование',
        'Криптовалютное обучение',
        'Обучение CFD',
      ],
    },
  },
  '/robot': {
    title: {
      en: 'Custom Forex Robot | GoVPSFX',
      ru: 'Форекс робот на заказ | GoVPSFX',
    },
    description: {
      en: 'GoVPSFX offers services for creating advisors, trading indicators, and scripts for MetaTrader 4 or MetaTrader 5 of any complexity.',
      ru: 'Компания GoVPSFX предлагает услуги по созданию советников, торговых индикаторов, скриптов для MetaTrader 4 или MetaTrader 5 любой сложности.',
    },
    keywords: {
      en: [
        'Create advisor',
        'Trading advisor',
        'Forex advisor',
        'Trading robot',
        'Forex trading robot',
        'Trading expert',
        'Forex advisor',
        'Forex robot',
        'Trading indicator',
        'VPS server',
        'Free VPS',
        'VPS',
      ],
      ru: [
        'создаю советника',
        'торговый советник',
        'forex советник',
        'торговый робот',
        'торговый форекс робот',
        'торговый эксперт',
        'форекс советник',
        'форекс робот',
        'торговый индикатор',
        'vps сервер',
        'бесплатный vps',
        'vps',
      ],
    },
  },
  '/glossary': {
    title: {
      en: 'Glossary of Terms - GoVPSFX',
      ru: 'Глоссарий терминов - GoVPSFX',
    },
    description: {
      en: 'Understand the world of forex with our comprehensive glossary of terms. From basic concepts to complex strategies, everything a trader needs to know. Improve your knowledge and confidence in trading!',
      ru: 'Разберитесь в мире форекс с нашим исчерпывающим глоссарием терминов. От базовых понятий до сложных стратегий — все, что нужно знать трейдеру. Улучшите свои знания и уверенность в торговле!',
    },
    keywords: {
      en: [
        'Forex Glossary',
        'Forex Terms',
        'Forex Definitions',
        'Trading Dictionary',
        'Forex Education',
        'Forex terminology',
        'Forex Concepts',
        'Forex Guide',
        'Forex Training',
        'Trading Terms',
      ],
      ru: [
        'Глоссарий форекс',
        'Форекс термины',
        'Определения форекс',
        'Трейдинг словарь',
        'Форекс образование',
        'Терминология форекс',
        'Понятия форекс',
        'Руководство по форекс',
        'Форекс обучение',
        'Трейдинг термины',
      ],
    },
  },
  // COURSES
  '/forex': {
    title: {
      en: 'All about Forex | GoVPSFX',
      ru: 'Всё о Форекс | GoVPSFX',
    },
    description: {
      en: 'What is a currency exchange? Can I make money on Forex? Is it true that all brokers are scammers? If you are looking for answers to these questions, you have come to the right place.',
      ru: 'Что такое валютная биржа? Можно ли заработать на Форекс? Правда ли, что все брокеры - мошенники? Если ты ищешь ответы на эти вопросы то ты попал по адресу',
    },
    keywords: {
      en: ['новичок форекс', 'форекс для новичков', 'зарабатывать форекс'],
      ru: ['Forex beginner', 'forex for beginners', 'make money forex'],
    },
  },
  '/cryptocurrency': {
    title: {
      en: 'All about Cryptocurrency | GoVPSFX',
      ru: 'Все о Криптовалюте | GoVPSFX',
    },
    description: {
      en: 'Only a lazy person today has not heard about the cryptocurrency market, bitcoin and blockchain. But hearing doesnt mean understanding',
      ru: 'Только ленивый сегодня не слышал о рынке криптовалют, биткоине и блокчейн. Но слышать - не значит понимать',
    },
    keywords: {
      en: [
        'how to make money on cryptocurrency',
        'new bitcoin',
        'cryptocurrency trading',
        'cryptocurrency market',
        'digital gold',
      ],
      ru: [
        'как зарабатывать на криптовалюте',
        'новый биткоин',
        'торговля криптовалютой',
        'рынок криптовалют',
        'цифровое золото',
      ],
    },
  },
  '/options': {
    title: {
      en: 'Binary Options for Dummies | GoVPSFX',
      ru: 'Бинарные опционы для чайников | GoVPSFX',
    },
    description: {
      en: 'Binary options are, in a sense, a universal exchange instrument with which you can not only earn money, but also insure your risks.',
      ru: 'Бинарные опционы - в каком-то смысле, универсальный биржевой инструмент, с помощью которого можно не только заработать, но и застраховать риски.',
    },
    keywords: {
      en: [
        'binary options trading',
        'binary options traders',
        'binary options for beginners',
      ],
      ru: [
        'торговля бинарными опционами',
        'трейдеры бинарных опционов',
        'бинарные опционы для новичков',
      ],
    },
  },
  '/cfd': {
    title: {
      en: 'Contracts For Difference (CFD) - GoVPSFX',
      ru: 'Контракты на разницу цен (CFD) - GoVPSFX',
    },
    description: {
      en: 'CFD (Contract For Difference) stands for Contract For Difference.',
      ru: 'CFD (Contract For Difference) в переводе означает контракт на разницу.',
    },
    keywords: {
      en: [
        'cfd',
        'cfd trading',
        'cfd for stocks',
        'cfd contract',
        'forex broker',
      ],
      ru: [
        'cfd',
        'торговля cfd',
        'cfd на акции',
        'cfd контракт',
        'форекс брокер',
      ],
    },
  },
  // ABOUT US
  '/about-us': {
    title: {
      en: 'About us | GoVPSFX',
      ru: 'О нас | GoVPSFX',
    },
    description: {
      en: 'Meet our team of professionals providing reliable VPS servers for forex traders. Learn about our development journey and future plans to stay ahead in the trading world.',
      ru: 'Познакомьтесь с нашей командой профессионалов, предоставляющих надежные VPS серверы для форекс трейдеров. Узнайте о нашем пути развития и планах на будущее, чтобы всегда быть на шаг впереди в мире трейдинга.',
    },
    keywords: {
      en: [
        'Hosting company team',
        'Road map',
        'VPS servers for Forex',
        'Professional trader support',
        'Hosting development plans',
        'About the company',
        'Forex infrastructure',
        'Reliable hosting',
        'Innovations in trading',
        'Partnership with traders',
      ],
      ru: [
        'Команда хостинг компании',
        'Road Map',
        'VPS серверы для Форекс',
        'Профессиональная поддержка трейдеров',
        'Планы развития хостинга',
        'О компании',
        'Форекс инфраструктура',
        'Надежный хостинг',
        'Инновации в трейдинге',
        'Партнерство с трейдерами',
      ],
    },
  },
};

export default tags;
